export default {
  mediaChannel: 'Canal de Medios',
  min: 'Mín',
  max: 'Máx'
}
